import React, { Fragment } from 'react';
import Link from 'shared/SlashLink';
import locations from '../../data/locations';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';

const ClickHandler = () => window.scrollTo(10, 0);

const LocationsHubPage = () => {
    usePageSeo({
        title: 'Service Areas — Low-Voltage & Managed IT',
        description: 'Low-voltage design, surveillance, managed IT, and cyber security across California — San Diego, Los Angeles, the Inland Empire, Sacramento, and the Bay Area.',
        keywords: 'low voltage contractor California, managed IT California, structured cabling, affordable housing technology, San Diego, Los Angeles, Sacramento, Fresno, Bay Area, BUILDLAB service areas',
    });

    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content">
                <PageTitle pageTitle={'Service Areas'} pagesub={'California'} pageTop={'Where We Work'} />
                <section className="section_space bg-light">
                    <div className="container">
                        <div className="text-center mb-5" style={{ maxWidth: 760, margin: '0 auto' }}>
                            <h2 className="mb-3">Serving developers &amp; businesses across California</h2>
                            <p className="m-0 text-muted">
                                BUILDLAB is headquartered in Escondido and works statewide — designing, building, and running
                                technology for affordable-housing and commercial projects, and providing managed IT to businesses.
                                Pick your area below.
                            </p>
                        </div>
                        <div className="row">
                            {locations.map((l) => (
                                <div className="col-lg-4 col-md-6 mb-4" key={l.slug}>
                                    <Link onClick={ClickHandler} to={`/locations/${l.slug}`} style={{ display: 'block', textDecoration: 'none', color: 'inherit', height: '100%' }}>
                                        <div style={{ background: '#fff', border: '1px solid var(--bs-border-color)', borderRadius: 14, padding: '24px 26px', height: '100%' }}>
                                            <div style={{ color: 'var(--bs-primary)', fontWeight: 700, fontSize: '.75rem', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 4 }}>{l.region}</div>
                                            <h3 style={{ fontSize: '1.15rem', marginBottom: 6 }}>{l.city}, CA <i className="fa-solid fa-arrow-up-right" aria-hidden="true" style={{ fontSize: '.7rem', color: 'var(--bs-primary)' }}></i></h3>
                                            <div style={{ fontSize: '.82rem', color: 'var(--bs-secondary-color)', marginBottom: 8 }}>{l.county}</div>
                                            <p className="m-0" style={{ fontSize: '.88rem', color: 'var(--bs-body-color)' }}>{l.blurb}</p>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                        <p className="text-center mt-3" style={{ fontSize: '.9rem' }}>
                            Not listed? We serve the entire state — <Link onClick={ClickHandler} to="/contact">tell us about your project</Link>.
                        </p>
                    </div>
                </section>
                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default LocationsHubPage;
